module.exports = __webpack_public_path__ + "img/flow_target.066a36e7.png";